import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="main"
        className="main-content main-content--page main-content--page--margin"
      >
        <div className="shopify-section">
          <div className="page-title">
            <h1>DELIVERY INFORMATION</h1>
          </div>
          <div className="policy-content">
            <p>
              We deliver within the UK, EU and internationally. Please note we
              do not deliver to Japan or PO Box addresses. For Japanese orders
              please visit our Japan website. We are currently unable to ship to
              Ukraine, Russia and Belarus.
            </p>

            <h2>UK DELIVERY</h2>

            <h3>Standard Delivery</h3>
            <p>
              Standard UK delivery takes 3-5 working days from dispatch.
              Delivery is free on all orders over £100. Orders under £100 incur
              a delivery charge of £5.
            </p>

            <h3>Next Day Delivery</h3>
            <p>
              Next day delivery is available on orders placed before 2pm Monday
              to Thursday for delivery the following working day. Orders placed
              after 2pm Thursday will be delivered the following Monday. Next
              day delivery costs £10.
            </p>

            <h3>Saturday Delivery</h3>
            <p>
              Saturday delivery is available on orders placed before 2pm Friday
              for delivery the following Saturday. Saturday delivery costs £15.
            </p>

            <h2>INTERNATIONAL DELIVERY</h2>

            <h3>European Union</h3>
            <p>
              All orders to the EU are shipped inclusive of duties and tax. No
              further costs will be charged on receipt of the order. Standard EU
              delivery takes 5-7 working days from dispatch. Delivery is free on
              all orders over £200. Orders under £200 incur a delivery charge of
              £10.
            </p>

            <h3>Rest of World</h3>
            <p>
              International delivery times vary depending on destination but
              typically take 7-14 working days from dispatch. All international
              orders are shipped on a DDP (Delivery Duty Paid) basis, meaning
              duties and taxes are included in the price you pay at checkout.
            </p>
            <p>
              Delivery charges for international orders are calculated at
              checkout based on the delivery address and order weight.
            </p>

            <h2>ORDER PROCESSING</h2>
            <p>
              Orders are processed and dispatched Monday to Friday. Orders
              placed over the weekend or on UK public holidays will be processed
              on the next working day.
            </p>
            <p>
              Please allow 1-2 working days for order processing before
              dispatch. Once your order has been dispatched, you will receive a
              confirmation email with tracking information.
            </p>

            <h2>DELIVERY UPDATES</h2>
            <p>
              You will receive email updates at each stage of your delivery,
              including order confirmation, dispatch notification, and delivery
              confirmation. You can track your order using the tracking number
              provided in your dispatch email.
            </p>

            <h2>DELIVERY ISSUES</h2>
            <p>
              If you have any issues with your delivery, or if you have not
              received your order within the expected timeframe, please contact
              our customer service team who will be happy to assist you.
            </p>

            <div className="info-box">
              <p>
                <strong>Please note:</strong> We cannot be held responsible for
                delays caused by customs clearance or courier services beyond
                our control.
              </p>
            </div>

            <h2>CONTACT US</h2>
            <p>
              If you have any questions about delivery, please contact our
              customer service team at{" "}
              <Link onClick={toTop} to="/contact">
                upper@margotal.art
              </Link>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Delivery;
